// extracted by mini-css-extract-plugin
export var grid = "_2e-0";
export var span1 = "_2e-2";
export var span10 = "_2e-b";
export var span10L = "_2e-z";
export var span10M = "_2e-n";
export var span10Xl = "_2e-1b";
export var span11 = "_2e-c";
export var span11L = "_2e-10";
export var span11M = "_2e-o";
export var span11Xl = "_2e-1c";
export var span12 = "_2e-d";
export var span12L = "_2e-11";
export var span12M = "_2e-p";
export var span12Xl = "_2e-1d";
export var span1L = "_2e-q";
export var span1M = "_2e-e";
export var span1Xl = "_2e-12";
export var span2 = "_2e-3";
export var span2L = "_2e-r";
export var span2M = "_2e-f";
export var span2Xl = "_2e-13";
export var span3 = "_2e-4";
export var span3L = "_2e-s";
export var span3M = "_2e-g";
export var span3Xl = "_2e-14";
export var span4 = "_2e-5";
export var span4L = "_2e-t";
export var span4M = "_2e-h";
export var span4Xl = "_2e-15";
export var span5 = "_2e-6";
export var span5L = "_2e-u";
export var span5M = "_2e-i";
export var span5Xl = "_2e-16";
export var span6 = "_2e-7";
export var span6L = "_2e-v";
export var span6M = "_2e-j";
export var span6Xl = "_2e-17";
export var span7 = "_2e-8";
export var span7L = "_2e-w";
export var span7M = "_2e-k";
export var span7Xl = "_2e-18";
export var span8 = "_2e-9";
export var span8L = "_2e-x";
export var span8M = "_2e-l";
export var span8Xl = "_2e-19";
export var span9 = "_2e-a";
export var span9L = "_2e-y";
export var span9M = "_2e-m";
export var span9Xl = "_2e-1a";
export var stretch = "_2e-1";